import { render } from "./GameTextsBox.vue?vue&type=template&id=5c5ce312"
import script from "./GameTextsBox.vue?vue&type=script&lang=js"
export * from "./GameTextsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__